import { notify } from '@kyvg/vue3-notification'
import { setupLayouts } from 'virtual:generated-layouts'
import routes from 'virtual:generated-pages'
import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '~/composables/auth'
import { requiredMinLevelForPath } from '~/composables/menu'
import { i18n } from '~/libs/i18n'
import { useUserStore } from '~/store'
import { canAccessAdminLevel } from '~/utils/admin-level'

export const router = createRouter({
  history: createWebHistory(),
  routes: setupLayouts(routes),
})

function translate(key: string): string {
  return (i18n.global as unknown as { t: (k: string) => string }).t(key)
}

router.beforeEach(async (to) => {
  const minLevel = requiredMinLevelForPath(to.path)
  if (!minLevel)
    return true

  const userStore = useUserStore()
  if (!userStore.user) {
    const auth = useAuth()
    const ok = await auth.checkToken()
    if (!ok)
      return { path: '/' }
  }

  if (canAccessAdminLevel(userStore.user?.level, minLevel))
    return true

  notify({
    text: translate('VOCE_NAO_TEM_NIVEL_ADMIN'),
    title: translate('common.error'),
    type: 'error',
  })
  return { path: '/dashboard' }
})
